import { render, staticRenderFns } from "./upload-papers.html?vue&type=template&id=73561f26&scoped=true&external"
import script from "./upload-papers.js?vue&type=script&lang=js&external"
export * from "./upload-papers.js?vue&type=script&lang=js&external"
import style0 from "./upload-papers.scss?vue&type=style&index=0&id=73561f26&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73561f26",
  null
  
)

export default component.exports